module.exports = __webpack_public_path__ + "files/84df9c1d8a0eecdee4ae8d8f23597140.png";